import { render } from "./RssResultListPage.vue?vue&type=template&id=80c9918e"
import script from "./RssResultListPage.vue?vue&type=script&lang=js"
export * from "./RssResultListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__